import { ComponentConstants } from "../../components/ComponentConstants";
import {StringUtils} from "./StringUtils";

export class WebUtils {

  public static getObjectReference(value:string, base:object) {
    return value.split('.').reduce((obj, i) => {
      const reference = obj[i];
      if(reference) {
        return reference;
      }
      throw Error(`Argument value with value ${value} does not exist.`);
    }, base);
  }

  public static sleep(duration:number) {
    return new Promise(resolve => setTimeout(resolve, duration));
  }

  public static getTransitionDuration(element: HTMLElement): number {
    return parseFloat(getComputedStyle(element).transitionDuration) * 1000;
  }

  public static isValidEscapeKey(event:KeyboardEvent):boolean {
    return((event["keyCode"] && event.keyCode == 27)||(event["key"] && event.key == "Escape")||(event["code"] && event.key == "Escape"));
  }

  public static appendElement(parent:HTMLElement, element?:HTMLElement, elementRequired:boolean = false):void {
    if(element) {
      parent.appendChild(element);
    }
    else if(elementRequired) {
      throw Error("Argument element is null and marked as required.");
    }
  }

  public static generateClasses(classes:string[], value:string):string {
    let results = new Set<string>(classes);
    new Set<string>(value.split(StringUtils.SPACE_SEPARATOR)).forEach(results.add, results);
    return StringUtils.join(results, StringUtils.SPACE_SEPARATOR);
  }

  public static getAbsoluteHeight(el: HTMLElement): number {
    // Get the DOM Node if you pass in a string
    el = (typeof el === 'string') ? document.querySelector(el) : el;

    var styles = window.getComputedStyle(el);
    var margin = parseFloat(styles['marginTop']) +
                 parseFloat(styles['marginBottom']);

    return Math.ceil(el.offsetHeight + margin);
  }

  public static getObjectFromString(string: string) {
    try {
      return JSON.parse(string);
    }
    catch(e) {
      throw new Error("Error!");
    }
  }

  public static getMediaQueryInstances() {
    const mediaQueryInstances = [
      {
        name: 'extra-small',
        mediaQueryList: window.matchMedia(`(max-width: ${ComponentConstants.EXTRA_SMALL.getRight()}px)`)
      },
      {
        name: 'small',
        mediaQueryList: window.matchMedia(`(min-width: ${ComponentConstants.SMALL.getLeft()}px) and (max-width: ${ComponentConstants.SMALL.getRight()}px)`)
      },
      {
        name: 'medium',
        mediaQueryList: window.matchMedia(`(min-width: ${ComponentConstants.MEDIUM.getLeft()}px) and (max-width: ${ComponentConstants.MEDIUM.getRight()}px)`)
      },
      {
        name: 'large',
        mediaQueryList: window.matchMedia(`(min-width: ${ComponentConstants.LARGE.getLeft()}px) and (max-width: ${ComponentConstants.LARGE.getRight()}px)`)
      },
      {
        name: 'extra-large',
        mediaQueryList: window.matchMedia(`(min-width: ${ComponentConstants.EXTRA_LARGE.getLeft()}px)`)
      }
    ]
    return mediaQueryInstances;
  }
}

